(function() {
	"use strict";

	angular.module( "ATMGurus" )


	/**
	*
	*		Training Classes booking Service
	*
	*	provdes persistence and it's there in case we need to expand it
	*
	*/
	.service( "classesBookingService", [
		"ApiQuery",
		"$filter",
		"$q",
		"$rootScope",
		function( ApiQuery, $filter, $q, $rootScope ) {

			var _this = this;
			var defer = $q.defer();

			// stores list of booked classes
			var bookedClasses = {};
			// class list
			var classes = {};
			// are we loading stuff?
			var loadingClasses = undefined;


			/**
			*
			*		Fetch classes List
			*
			*/
			var loadClasses = function() {
				loadingClasses = true;
				ApiQuery( "training/schedule", "", "GET" )
					.then( function( response ) {
						loadingClasses = false;
						classes = response.data.data;
						_.forEach( response.data.data, function( item, key ) {
							item.start_date = moment(item.start_date).format( 'MMM DD, YYYY - ' )
							item.end_date = moment(item.end_date).format( 'MMM DD, YYYY' )
						} )
						defer.resolve( classes )
					} )
				return defer.promise;
			}()

			return {
				book: function( classDetails ) {
					if ( ! angular.isDefined( bookedClasses[ classDetails.id ]) ) {
						bookedClasses[ classDetails.id ] = classDetails;
					}
					else {
						delete bookedClasses[ classDetails.id ]
					}
				},
				getClasses: function() {
					if ( loadingClasses ) {
						return defer.promise
					}
					else {
						defer.resolve( classes )
					}
					return defer.promise;
				},
				getBookedClasses: function() {
					return bookedClasses;
				},
				resetBookedClasses: function() {
					bookedClasses = {};
				},
				loading: function() {
					return loadingClasses
				},
				bookedClasses: bookedClasses
			}
		}
	] )

})()



// WEBPACK FOOTER //
// ./src/app/services/ClassesBookingService.js